import React from 'react';
import MaterialTable from 'material-table';
import { Grid, AppBar, Toolbar, makeStyles, Typography } from '@material-ui/core';
import ExportBadges from './exports/ExportBadges';
import ExportDefault from './exports/ExportDefault';

const useStyles = makeStyles((theme) => ({
    bar: {
        borderTopLeftRadius: 20,
        borderTopRightRadius: 20
    }
}));

// Types
interface RowItem {
    email: string;
    firstName: string;
    lastName: string;
    achievements: string[];
}

interface IAchievementsReport {
    data: RowItem[]
}

const AchievementsReport: React.FC<IAchievementsReport> = ({ data }) => {
    const classes = useStyles();
    const columns = [
        { title: 'Name', field: 'firstName' },
        { title: 'Surname', field: 'lastName' },
        { title: 'Email', field: 'email' },
        {
            title: 'Total Achievements',
            field: 'achievements',
            type: 'numeric',
            render: (rowData: RowItem) =>
                rowData.achievements.length
        }
    ];

    const tableOptions = {
        paging: true,
        search: false,
        showTitle: false,
        actionsColumnIndex: -1,
        pageSizeOptions: [5, 20, 50, 100, 500],
    };

    return (
        <Grid container direction="column">
            <Grid item>
                <AppBar position="static" className={classes.bar}>
                    <Toolbar>
                        <Grid container justifyContent="space-between" alignItems="center">
                            <Grid item>
                                <Typography variant="h6">User Badges</Typography>
                            </Grid>
                            <Grid item>
                                <ExportDefault 
                                    sheetName={'Badges'}
                                    data={data} 
                                    columns={columns} />
                            </Grid>
                        </Grid>
                    </Toolbar>
                </AppBar>
            </Grid>

            <Grid item>
                <MaterialTable
                    columns={columns}
                    data={data || []}
                    options={tableOptions}
                    detailPanel={rowData => (
                        <div style={{ padding: 16 }}>
                            {rowData.achievements.map(a => (
                                <div key={a}>• {a}</div>
                            ))}
                        </div>
                    )}
                />
            </Grid>
        </Grid>
    );
};

export default AchievementsReport;